/* tslint:disable */

import { Log } from 'ng2-logger';
import React from 'react';
import { connect } from 'react-redux';
import {Modal } from 'reactstrap';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import { IAppState } from '../../models/action/core';
import * as Actions from '../../store/actions/examSession';

const _logger = Log.create('Processing Activity');
const T = Translator.create();
let _common: Common;
let canvasElement: any;


class AddMultiStudentModal extends React.Component<any, {userText: string, selectType: number, dispatch?: any;}> {

    
    constructor(props: any) {
        super(props);
        _common = new Common();
        canvasElement = React.createRef();
        this.state = {
            userText: '',
            selectType: 0,
        }
    }

    setClose = (refresh: boolean = false) => {
        if (this.props.onClose) {
            this.props.onClose(refresh);
        }
    };

    setCloseModal = () => {
        this.setClose();
    };

    setInputText = (e: any) =>
    {
         this.setState({userText: e.target.value}) 
    }

    postData = () =>
    {
        let users = this.state.userText.split('\n');
        this.props.dispatch(
            Actions.ExamSessionGetStudent(
                this.state.selectType,
                users,
                this.props.addMultiStudentsCallBack,
                'ExamSessionGetStudent',
                'get'
            )
        );

        this.setClose();
    }

    onRadioChange = (type: number) =>
    {
        this.setState({selectType: type});
    }
    render() {
       
        return (
            <Modal
                className=" exam-modal-stats"
                isOpen={this.props.modalIsOpen}
                toggle={this.setCloseModal}
                style={{ maxWidth: '1150px' }}
            >
                <div className='col-12 row'>
                    <div className='col-11 text-center font-weight-bold'>{T.t('r_gen_exam_session_get_students')}</div>
                    <div className='col-1 text-end'><button type="button" className="close p-0" onClick={this.setCloseModal} aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button></div>

                </div>
                <div className='col-12 row mt-4 p-2' style={{backgroundColor: "#fbf1df"}}>
                    <div className='col-12 small text-center'>{T.t('r_add_multiple_student_info')}</div>
                </div>

                <div className='col-12 row p-2 mt-2' >
                    <div className='col-4 ml-3'>
                    <div className="input-group">
                    <input
                                type="radio"
                                name={'multiUserPostType'}
                                onChange={this.onRadioChange.bind(this, 0)}
                                value={0}
                                checked={this.state.selectType === 0}
                                className="btn"
                                style={{ borderRadius: 100, marginTop: 2 }}
                            /><span className="input-group-addon ml-2 small" style={this.state.selectType === 0 ? {color: '#0b9dff'}: {color: 'black'}}>{T.t('r_by_username')}</span>
                        </div>

                    </div>
                    <div className='col-4'>
                    <div className="input-group">
                    <input
                                type="radio"
                                name={'multiUserPostType'}
                                onChange={this.onRadioChange.bind(this, 1)}
                                value={1}
                                className="btn"
                                checked={this.state.selectType === 1}
                                style={{ borderRadius: 100, marginTop: 2 }}
                            /><span className="input-group-addon ml-2 small"  style={this.state.selectType === 1 ? {color: '#0b9dff'}: {color: 'black'}}>{T.t('r_by_identity_number')}</span>
                        </div>

                    </div>
                    
                    <div className='col-4 small' >
                     </div>
                </div>

                <div className='row col-12'>
                <div className="row col-12 comment-question-add p-2 justify-content-center align-items-center m-0"  >
                <textarea name="postContent" className='m-0' style={{width: "100%", height: "300px", backgroundColor: "white", border: "1px solid #2525294d"}}  onChange={(e: any) => this.setInputText(e)}>{this.state.userText}</textarea>
                </div>
                </div>
                <div className='col-12 small p-0 justify-content-between d-flex'  style={{color: "#0b9dff", marginTop: "50px"}}>
                    <div>
                    <button type="button" className="btn btn-gray p-0" onClick={this.setCloseModal} aria-label="Close">{T.t('r_cancel')}</button>
                    </div>
                    <div>
                    <button type="button" className="btn btn-green p-0" onClick={this.postData} aria-label="Close">{T.t('r_save_button')}</button>
                    </div>
                    </div>

               
            </Modal>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: any): any => {
    if (!state) {
        return ownProps;
    }
    const multiUsers = {
        multiUsers: state.examSession.multiUsers
    }

    const newProps  = {...ownProps, ...multiUsers };

    return newProps;
};

const CAddMultiStudentModal = connect(
    mapStateToProps
)(AddMultiStudentModal);

export default CAddMultiStudentModal;
